export default __webpack_public_path__ + "static/media/member3.0d822ecc.jpg";